import React from "react";

import { DragDropContext, Draggable, Droppable, DropResult } from "react-beautiful-dnd";

import { ReorderIcon } from "shared/ui";

import { Empty, List, Name, Row } from "./styles";

export interface OrderEntry {
    id: number;
    label: string;
}

interface OrderListProps {
    entries: OrderEntry[];
    onReorder: (entries: OrderEntry[]) => void;
    emptyText: string;
}

const reorder = (entries: OrderEntry[], from: number, to: number) => {
    const result = [...entries];
    const [moved] = result.splice(from, 1);
    result.splice(to, 0, moved);

    return result;
};

/*
* Управляемый список с перетаскиванием: порядок держит вызывающий. Так один и тот же
* список работает и отдельным диалогом (категории), и вкладкой внутри другой формы
* (позиции в настройках категории), где сохранение общее с остальными полями.
* */
export const OrderList = ({ entries, onReorder, emptyText }: OrderListProps) => {
    if (entries.length === 0) return <Empty>{emptyText}</Empty>;

    const onDragEnd = (result: DropResult) => {
        if (!result.destination) return;

        onReorder(reorder(entries, result.source.index, result.destination.index));
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="menu-editor-order">
                {(droppable) => (
                    <List ref={droppable.innerRef} {...droppable.droppableProps}>
                        {entries.map((entry, index) => (
                            <Draggable
                                key={entry.id}
                                draggableId={String(entry.id)}
                                index={index}
                            >
                                {(draggable, snapshot) => (
                                    <Row
                                        ref={draggable.innerRef}
                                        {...draggable.draggableProps}
                                        {...draggable.dragHandleProps}
                                        $dragging={snapshot.isDragging}
                                    >
                                        <ReorderIcon />
                                        <Name>{entry.label}</Name>
                                    </Row>
                                )}
                            </Draggable>
                        ))}
                        {droppable.placeholder}
                    </List>
                )}
            </Droppable>
        </DragDropContext>
    );
};
